import React, { useState } from "react";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { Divider, Button, Select, Row, Col, Typography, Form } from "antd";
import ConfigureFundSource from "./accountingForm/ConfigureFundSource";
import MapFees from "./accountingForm/MapFees";
import MapPenalties from "./accountingForm/MapPenalties";

const { Title, Text } = Typography;

const UpfrontAccrualCheckForm = (props) => {
  const {
    defaultColumns,
    handleDelete,
    handleCheckboxChange,
    dataSource,
    showAdvanced,
    setShowAdvanced,
    assetAccountOptions,
    incomeAccountOptions,
    expenseAccountOptions,
    liabilityAccountOptions,
    paymentTypeOptions,
    charges,
    chargesOptions,
    penaltyOptions,
    userData,
    onFinish,
    fundCount,
    setFundCount,
    feeCount,
    setFeeCount,
    mapFeeTableSource,
    setMapFeeTableSource,
    configureFundTableSource,
    setConfigureFundTableSource,
    mapPenaltyTableSource,
    setMapPenaltyTableSource,
    penaltyCount,
    setPenaltyCount,
    form,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  return (
    <Row>
      <Divider orientation="left" orientationMargin="0">
        {" "}
        Assests
      </Divider>
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="fundSourceAccountId"
          label={<Text strong> Fund Source</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={assetAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="loanPortfolioAccountId"
          label={<Text strong>Loan Portfolio</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={assetAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="receivableInterestAccountId"
          label={<Text strong>Interests Receivable</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={assetAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="receivableFeeAccountId"
          label={<Text strong>Fees Receivable</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={assetAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="receivablePenaltyAccountId"
          label={<Text strong>Penalties Receivable</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={assetAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="transfersInSuspenseAccountId"
          label={<Text strong>Transfer In Suspense</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={assetAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Divider orientation="left" orientationMargin="0">
        {" "}
        Income
      </Divider>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="interestOnLoanAccountId"
          label={<Text strong>Income From Interest</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={incomeAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="incomeFromFeeAccountId"
          label={<Text strong>Income From Fees</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={incomeAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="incomeFromPenaltyAccountId"
          label={<Text strong>Income From Penalties</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={incomeAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="incomeFromRecoveryAccountId"
          label={<Text strong>Income From Recovery Payments</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={incomeAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Divider orientation="left" orientationMargin="0">
        {" "}
        Expenses
      </Divider>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="writeOffAccountId"
          label={<Text strong>Losses Written Off</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={expenseAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Divider orientation="left" orientationMargin="0">
        {" "}
        Liabilities
      </Divider>

      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="overpaymentLiabilityAccountId"
          label={<Text strong>Overpayment Liability</Text>}
          rules={[
            {
              required: true,
              message: "Required Field",
            },
          ]}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
            }
            allowClear
            options={liabilityAccountOptions}
            placeholder={"Select an Option"}
            showSearch
          />
        </Form.Item>
      </Col>

      <Divider orientation="left" orientationMargin="0">
        {" "}
        Advanced Accounting Rule{" "}
        <span>
          {showAdvanced ? (
            <>
              <Button
                type="dashed"
                onClick={() => setShowAdvanced(!showAdvanced)}
                icon={<DownOutlined />}
              >
                Hide
              </Button>
            </>
          ) : (
            <>
              <Button
                type="dashed"
                onClick={() => setShowAdvanced(!showAdvanced)}
                icon={<RightOutlined />}
              >
                Show
              </Button>
            </>
          )}
        </span>
      </Divider>

      {showAdvanced && (
        <div>
          <ConfigureFundSource
            onFinish={onFinish}
            form={form}
            userData={userData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            paymentTypeOptions={paymentTypeOptions}
            assetAccountOptions={assetAccountOptions}
            configureFundTableSource={configureFundTableSource}
            setConfigureFundTableSource={setConfigureFundTableSource}
            fundCount={fundCount}
            setFundCount={setFundCount}
          />
          <MapFees
            onFinish={onFinish}
            form={form}
            userData={userData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            charges={charges}
            incomeAccountOptions={incomeAccountOptions}
            mapFeeTableSource={mapFeeTableSource}
            setMapFeeTableSource={setMapFeeTableSource}
            feeCount={feeCount}
            setFeeCount={setFeeCount}
            chargesOptions={chargesOptions}
          />

          <MapPenalties
            onFinish={onFinish}
            form={form}
            userData={userData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            incomeAccountOptions={incomeAccountOptions}
            mapPenaltyTableSource={mapPenaltyTableSource}
            setMapPenaltyTableSource={setMapPenaltyTableSource}
            penaltyCount={penaltyCount}
            setPenaltyCount={setPenaltyCount}
            chargesOptions={chargesOptions}
            penaltyOptions={penaltyOptions}
          />
        </div>
      )}
    </Row>
  );
};

export default UpfrontAccrualCheckForm;
